export default {
	CPU: 'CPU',
	IP: 'IP',
	vps_console: {
		IP: 'IP',
		IPv4: 'IPv4',
		network_table: {
			'30_day': '最近30天',
			'7_day': '最近7天',
			to_day: '今天',
			to_month: '最近一个月',
		},
		'1个月': '1个月',
		'1年': '1年',
		'1小时': '1小时',
		'24小时': '24小时',
		'7天': '7天',
		百分比: '百分比',
		包转发率: '包转发率',
		本月: '本月',
		操作日志: '操作日志',
		操作系统: '操作系统',
		操作已取消: '操作已取消',
		出带宽: '出带宽',
		出站: '出站',
		创建时间: '创建时间',
		磁盘名称: '磁盘名称',
		磁盘信息: '磁盘信息',
		等待重启: '等待重启',
		读取速度: '读取速度',
		读取IOPS: '读取IOPS',
		断电关机: '断电关机',
		发送流量: '发送流量',
		分钟: '分钟',
		复制: '复制',
		概览: '概览',
		概要: '概要',
		格式化数据盘: '格式化数据盘',
		挂载: '挂载',
		关机: '关机',
		将重建至: '将重建至',
		接收流量: '接收流量',
		结束时间: '结束时间',
		今日: '今日',
		近7天: '近7天',
		进带宽: '进带宽',
		进度: '进度',
		敬请期待: '敬请期待',
		开机: '开机',
		开始时间: '开始时间',
		控制台: '控制台',
		类型: '类型',
		类型大小: '类型大小',
		流出: '流出',
		流出流量: '流出流量',
		流量: '流量',
		流量计费统计: '流量计费统计',
		流入: '流入',
		流入流量: '流入流量',
		秒: '秒',
		内存用量: '内存用量',
		平均流量: '平均流量',
		'请求超时，请稍后刷新页面查看': '请求超时，请稍后刷新页面查看',
		请输入端口: '请输入端口',
		请输入密码: '请输入密码',
		请先确认数据已完成备份: '请先确认数据已完成备份',
		请选择操作系统: '请选择操作系统',
		确定要断电关机吗: '确定要断电关机吗？',
		确定要关机吗: '确定要关机吗？',
		确定要重启吗: '确定要重启吗？',
		任务: '任务',
		任务类型: '任务类型',
		任务描述: '任务描述',
		入站: '入站',
		实例ID: '实例ID',
		随机生成: '随机生成',
		天: '天',
		图表: '图表',
		网卡: '网卡',
		我确认数据已完成备份: '我确认数据已完成备份',
		系统重装中: '系统重装中，请稍后刷新页面查看结果',
		小时: '小时',
		写入速度: '写入速度',
		写入IOPS: '写入IOPS',
		已持续运行: '已持续运行',
		已关机: '已关机',
		已用: '已用',
		硬盘IO: '硬盘IO',
		硬重启: '硬重启',
		用户名密码: '用户名密码',
		用量排行: '用量排行',
		远程: '远程',
		运行中: '运行中',
		正在重置密码: '正在重置密码',
		正在重装: '正在重装',
		执行中: '执行中',
		重建实例: '重建实例',
		重建实例警告: '重建实例将清除所有个人数据，请确认您已经完成备份。您确定要重建此实例吗?',
		重启: '重启',
		重置密码: '重置密码',
		重装: '重装',
		重装系统将会导致系统盘数据丢失: '重装系统将会导致系统盘数据丢失，确认重装？',
		重装系统确认: '重装系统确认',
		主: '主',
		主机名: '主机名',
		总计流量: '总计流量',
		总量: '总量',
		总流量: '总流量',
		最大流量: '最大流量',
		最新流量: '最新流量',
		CPU使用量: 'CPU使用量',
		IP地址: 'IP地址',
		SSH端口: 'SSH端口',
	},
	备注: '备注',
	本订单已有未处理的关闭申请工单号: '本订单已有未处理的关闭申请 <strong>{no}</strong>',
	本订单已有未处理的售后工单工单号: '本订单已有未处理的售后工单 <strong>{no}</strong>',
	操作: '操作',
	操作系统: '操作系统',
	产品: '产品',
	产品到期不续费: '（该产品已设定到期不续费，到期后产品将自动取消。）',
	产品到期续费: '（已允许手动续费，到期前将自动生成续费账单。）',
	产品价格: '产品价格',
	产品配置: '产品配置',
	产品信息: '产品信息',
	产品选择: '产品选择',
	带宽: '带宽',
	单价: '单价',
	到期不续费: '到期不续费',
	到期日期: '到期日期',
	登录信息: '登录信息',
	订单: '订单',
	订单编号: '订单编号',
	订单编号将于多少时间后关闭: '订单 {no} 将于 {time} 后关闭',
	订单管理: '订单管理',
	订单类型: '订单类型',
	订单信息: '订单信息',
	订单支付成功后将续费至日期: '订单支付成功后将续费至 <strong>{date}</strong>',
	端口: '端口',
	发票信息: '发票信息',
	返回: '返回',
	'服务器/cpu': '服务器/cpu',
	附加IP地址: '附加IP地址',
	复制: '复制',
	复制信息: '复制信息',
	该产品需要实名认证达标后购买: '该产品需要实名认证达标后购买',
	个: '个',
	更多: '更多',
	购买物理机: '购买物理机',
	购买云主机: '购买云主机',
	关闭订单: '关闭订单',
	关闭订单标题: '订单{no}关闭',
	关闭订单内容: '提交关闭订单，编号{no}，产品{product}，订单到期日期{date}',
	关闭原因必填: '请填写关闭原因',
	关闭原因占位: '说明关闭原因，例如：不再需要、迁移到其他服务等',
	核心: '核心',
	恢复续费账单: '恢复续费账单',
	机房: '机房',
	'机房/线路': '机房/线路',
	计费: '计费',
	计价周期: '计价周期',
	价格: '价格',
	开通日期: '开通日期',
	'开通日期/到期日期': '开通日期/到期日期',
	'开通日期/结束日期': '开通日期/结束日期',
	可选产品: '可选产品',
	可选线路: '可选线路',
	控制台: '控制台',
	库存: '库存',
	库存不足无法下单: '库存不足，无法下单',
	类型: '类型',
	历史订单: '历史订单',
	密码: '密码',
	名称: '名称',
	默认带宽: '默认带宽',
	默认内存: '默认内存',
	默认区域: '默认区域',
	默认数据盘: '默认数据盘',
	默认系统盘: '默认系统盘',
	默认CPU: '默认vCPU',
	默认IP数量: '默认IP数量',
	内存: '内存',
	配置: '配置',
	处理中: '处理中',
	请填写关闭原因: '请填写关闭原因，业务员收到后会与您联系处理',
	请至少改变一个配置: '请至少改变一个配置',
	区域: '区域',
	取消: '取消',
	缺货: '缺货',
	确认关闭编号为编号的订单: '确认关闭编号为<strong>{no}</strong>的订单?',
	确认关闭订单提示: '确认提交关闭订单 <strong>{no}</strong> 的申请？业务员收到后会与您联系处理。',
	'确认要到期不续费吗？': '确认要到期不续费吗？',
	'确认要恢复续费账单吗？': '确认要恢复续费账单吗？',
	申请已提交工单号: '工单已提交，工单号 <strong>{no}</strong>',
	升级配置: '升级配置',
	生成发票: '续费',
	剩余: '剩余',
	试用开通日期: '试用开通日期',
	试用中: '试用中',
	输入订单编号查询: '输入订单编号查询',
	数据盘: '数据盘',
	刷新: '刷新',
	提交订单: '提交订单',
	提示: '提示',
	网络: '网络',
	未关联主机: '未关联主机',
	系统盘: '系统盘',
	下单时间: '下单时间',
	线路: '线路',
	线路带宽: '线路带宽',
	详情: '详情',
	修改配置后生成: '修改配置后生成',
	已启用: '已启用',
	已失效: '已失效',
	已停用: '已停用',
	硬盘: '硬盘',
	用户名: '用户名',
	远程端口: '远程端口',
	月: '月',
	暂无可用线路: '暂无可用线路',
	支付: '支付账单',
	支付补差价: '支付补差价',
	重置配置: '重置配置',
	主机名: '主机名',
	主机信息: '主机信息',
	状态: '状态',
	字段不能小于原配置: '{field}不能小于原配置',
	自定义: '自定义',
	自动生成: '自动生成',
	自动续费: '自动续费',
	总计: '总计',
	IP地址: 'IP地址',
	IP配置: 'IP配置',
	IP数量: 'IP数量',
	IP数量限制: 'IP数量限制',
	MAC地址: 'MAC地址',
	VPS信息: 'VPS信息',
}
